'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _CameraIcon = require('../CameraIcon');

var _CameraIcon2 = _interopRequireDefault(_CameraIcon);

var _SurfConditions = require('../SurfConditions');

var _SurfConditions2 = _interopRequireDefault(_SurfConditions);

var _generateSlug = require('../helpers/generateSlug');

var _generateSlug2 = _interopRequireDefault(_generateSlug);

var _spotPagePath = require('../helpers/spotPagePath');

var _spotPagePath2 = _interopRequireDefault(_spotPagePath);

var _taxonomyNodePropType = require('../PropTypes/taxonomyNodePropType');

var _taxonomyNodePropType2 = _interopRequireDefault(_taxonomyNodePropType);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RenderSpot = function RenderSpot(_ref) {
  var spot = _ref.spot,
      onClickLink = _ref.onClickLink;

  var getClassName = function getClassName() {
    return (0, _classnames2.default)({
      'quiver-render-spot': true,
      'quiver-render-spot--last-of-group': spot.lastOfGroup
    });
  };

  var getHref = function getHref(_ref2) {
    var associated = _ref2.associated,
        _id = _ref2._id,
        name = _ref2.name;

    if (associated) {
      return associated.links.find(function (link) {
        return link.key === 'www';
      }).href;
    }
    var slug = (0, _generateSlug2.default)(name);
    return (0, _spotPagePath2.default)(_id, slug);
  };
  return _react2.default.createElement(
    'div',
    { className: getClassName() },
    _react2.default.createElement(_SurfConditions2.default, {
      conditions: spot.conditions ? spot.conditions.value || 'NONE' : 'NONE'
    }),
    _react2.default.createElement(
      'a',
      {
        href: getHref(spot),
        onClick: function onClick() {
          return onClickLink({
            clickEndLocation: 'Spot',
            destinationUrl: getHref(spot),
            completion: true,
            linkName: spot.name
          }, true);
        }
      },
      spot.name
    ),
    spot.hasCamera || spot.cameras && spot.cameras.length > 0 ? _react2.default.createElement(_CameraIcon2.default, null) : null
  );
};

RenderSpot.propTypes = {
  spot: _taxonomyNodePropType2.default,
  onClickLink: _propTypes2.default.func
};

RenderSpot.defaultProps = {
  onClickLink: null
};

exports.default = RenderSpot;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/RenderSpot/RenderSpot.js
// module id = 636
// module chunks = 11